/* NSCREATION - barre d'annonces defilante : le texte sort d'un cote et le suivant arrive de l'autre */
(function () {
  if (customElements.get('nsc-announcement')) return;

  class NscAnnouncement extends HTMLElement {
    connectedCallback() {
      this.slides = Array.prototype.slice.call(this.querySelectorAll('.nsc-ann__slide'));
      this.index = 0;
      this.busy = false;
      this.paused = false;
      this.timer = null;
      this.flip = this.getAttribute('data-direction') === 'right';
      this.auto = this.getAttribute('data-auto') === 'true';
      this.delay = (parseInt(this.getAttribute('data-speed'), 10) || 4) * 1000;

      this.initBehavior();

      if (this.slides.length < 2) return;

      var self = this;
      this.addEventListener('click', function (event) {
        var button = event.target.closest('[data-nsc-ann]');
        if (!button) return;
        self.step(button.getAttribute('data-nsc-ann') === 'next' ? 1 : -1);
        self.restart();
      });

      this.addEventListener('mouseenter', function () { self.paused = true; });
      this.addEventListener('mouseleave', function () { self.paused = false; });
      this.addEventListener('focusin', function () { self.paused = true; });
      this.addEventListener('focusout', function () { self.paused = false; });

      /* Editeur Shopify : selectionner une annonce l'affiche */
      this.addEventListener('shopify:block:select', function (event) {
        self.paused = true;
        var slide = event.target.closest('.nsc-ann__slide');
        var target = self.slides.indexOf(slide);
        if (target > -1 && target !== self.index) self.go(target, target > self.index ? 1 : -1);
      });
      this.addEventListener('shopify:block:deselect', function () { self.paused = false; });

      this.start();
    }

    disconnectedCallback() {
      this.stop();
      if (this.onScroll) {
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onScroll);
      }
    }

    /* Comportement au defilement de la page : always, hide_down, top_only, after_distance (scroll = normal) */
    initBehavior() {
      var mode = this.getAttribute('data-behavior') || 'scroll';
      if (mode === 'scroll') return;

      var self = this;
      var wrapper = this.closest('.shopify-section');
      var distance = parseInt(this.getAttribute('data-distance'), 10) || 300;
      var lastY = window.scrollY || 0;
      var hidden = false;

      function apply(hide) {
        hidden = hide;
        if (wrapper) {
          wrapper.classList.toggle('is-hidden', hide);
          wrapper.inert = hide;
        }
        document.documentElement.style.setProperty('--nsc-ann-offset', hide ? '0px' : self.offsetHeight + 'px');
      }

      this.onScroll = function () {
        var y = window.scrollY || document.documentElement.scrollTop || 0;
        var hide = false;

        if (mode === 'top_only') {
          hide = y > 4;
        } else if (mode === 'after_distance') {
          hide = y > distance;
        } else if (mode === 'hide_down') {
          if (y <= 10) hide = false;
          else if (y > lastY + 4 && y > self.offsetHeight) hide = true;
          else if (y < lastY - 4) hide = false;
          else hide = hidden;
        }

        lastY = y;
        if (hide !== hidden || wrapper && !wrapper.hasAttribute('data-nsc-ready')) {
          if (wrapper) wrapper.setAttribute('data-nsc-ready', 'true');
          apply(hide);
        }
      };

      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onScroll);
      this.onScroll();
    }

    start() {
      var self = this;
      if (!this.auto) return;
      this.stop();
      this.timer = window.setInterval(function () {
        if (!self.paused && !document.hidden) self.step(1);
      }, this.delay);
    }

    stop() {
      if (this.timer) window.clearInterval(this.timer);
      this.timer = null;
    }

    restart() {
      if (this.auto) this.start();
    }

    step(delta) {
      var count = this.slides.length;
      this.go((this.index + delta + count) % count, delta);
    }

    /* delta > 0 : annonce suivante. Par defaut le texte sort a gauche et le suivant arrive par la droite. */
    go(nextIndex, delta) {
      if (this.busy || nextIndex === this.index) return;
      this.busy = true;

      var current = this.slides[this.index];
      var next = this.slides[nextIndex];
      var visual = this.flip ? -delta : delta;
      var from = visual > 0 ? 'is-from-right' : 'is-from-left';
      var to = visual > 0 ? 'is-to-left' : 'is-to-right';

      next.classList.add('is-instant', from);
      void next.offsetWidth;
      next.classList.remove('is-instant');

      current.classList.remove('is-active');
      current.classList.add(to);
      current.setAttribute('aria-hidden', 'true');

      next.classList.remove(from);
      next.classList.add('is-active');
      next.removeAttribute('aria-hidden');

      this.index = nextIndex;
      var self = this;
      window.setTimeout(function () {
        current.classList.remove(to);
        self.busy = false;
      }, 750);
    }
  }

  customElements.define('nsc-announcement', NscAnnouncement);
})();
